import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import useSuspenseFetch from '../hooks/useSuspenseFetch';
import SplashScreen from '../splashScreen/SplashScreen';
import SelectAccountDialog from '../dialogs/SelectAccountDialog';
import AgreeToTermsDialog from '../dialogs/AgreeToTermsDialog';
import InvalidLicenceDialog from '../dialogs/InvalidLicenceDialog';

const UserChecker = ({ children }) => {
  const { data: user } = useSuspenseFetch('user');

  // todo this refreshes auth token immediately after account linking, could be better

  if (user.refreshRequired) {
    window.location.assign('/');
    return <SplashScreen />;
  }

  if (!user.account) return <SelectAccountDialog />;
  if (!user.hasAgreed) return <AgreeToTermsDialog />;
  if (!user.account.licence) return <InvalidLicenceDialog />;

  return children;
};

// todo these can be merged when Auth0 implements suspense-enabled fetching

const AuthLoader = ({ children }) => {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();

  if (isLoading) return <SplashScreen />;

  if (!isAuthenticated) {
    console.warn('User not authenticated! Send them back to login screen.');
    loginWithRedirect();
    return <SplashScreen />;
  }

  return (
    <UserChecker>
      {children}
    </UserChecker>
  );
};

export default AuthLoader;